import { FieldProps } from 'formik'
import { FormikToggle } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { isInProvingRole } from 'helpers'
import { useAuthContext } from 'hooks/useAuthContext'
import { Proving, ProvingUserRole, UserRole } from 'model'
import { Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export interface ProvingDetailsNmfValues {
  requirement: boolean
  release: boolean
  transport: boolean
  informed: boolean
}

export const ProvingDetailsNmfForm: React.FC<{ proving: Proving }> = ({
  proving,
}) => {
  const { t } = useTranslation()
  const auth = useAuthContext()
  const isProvingResourceManager = isInProvingRole(
    proving,
    ProvingUserRole.ResourceManager
  )
  const isAdmin = auth.hasUserRole(UserRole.SystemAdministrator)
  const isResourceManager = auth.hasUserRole(UserRole.ResourceManager)
  const canUpdate = isProvingResourceManager
    ? true
    : isAdmin
    ? true
    : isResourceManager
    ? true
    : false
  return (
    <FormStack>
      <FieldStack>
        <Label>{t('Bedarf melden')}</Label>
        <FieldStackItem
          name="nmf.requirement"
          render={(fieldProps: FieldProps<ProvingDetailsNmfValues>) => {
            return <FormikToggle {...fieldProps} />
          }}
        />
      </FieldStack>
      <FieldStack>
        <Label>{t('Freigabe erteilt')}</Label>
        <FieldStackItem
          name="nmf.release"
          render={(fieldProps: FieldProps<ProvingDetailsNmfValues>) => {
            return <FormikToggle disabled={!canUpdate} {...fieldProps} />
          }}
        />
      </FieldStack>
      <FieldStack>
        <Label>{t('Transport wurde beauftragt')}</Label>
        <FieldStackItem
          name="nmf.transport"
          render={(fieldProps: FieldProps<ProvingDetailsNmfValues>) => {
            return <FormikToggle disabled={!canUpdate} {...fieldProps} />
          }}
        />
      </FieldStack>
      <FieldStack>
        <Label>{t('Standort wurde informiert')}</Label>
        <FieldStackItem
          name="nmf.informed"
          render={(fieldProps: FieldProps<ProvingDetailsNmfValues>) => {
            return <FormikToggle disabled={!canUpdate} {...fieldProps} />
          }}
        />
      </FieldStack>
    </FormStack>
  )
}
